"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_date_range_picker_1 = __importDefault(require("@uswds/uswds/js/usa-date-range-picker"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function DateRangePicker({ children, className }) {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_date_range_picker_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_date_range_picker_1.default.off(containerEl);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('bah-uswds-date-range-picker', className), ref: containerRef, children: (0, jsx_runtime_1.jsx)("div", { className: "usa-date-range-picker", children: children }) }));
}
exports.default = DateRangePicker;
